export default __webpack_public_path__ + "static/media/SWT1900.34I-40839_-24222_0.a4632e1d.jpg";